// utm_* с первого захода на сайт — до анкеты /start и /tutors/join (25.10.2026).
//
// Браузер: на каждом переходе (__root) адрес с utm_* запоминается в
// localStorage («последний рекламный заход»), живёт 30 дней. При отправке
// анкеты utm_source и utm_campaign уходят на сервер и пишутся в
// pretest_sessions / map_partners (миграция 20261111120000).
// Всё в try/catch и без ожидания: недоступное хранилище, блокировщик или
// странное значение не мешают ни странице, ни отправке — поля просто пустые.
//
// Без серверных импортов: модуль читают __root, /start, форма join, сервер
// (normalizeUtm) и scripts/verify-owner-signals.mts.

export const UTM_KEY = "yt_utm";
export const UTM_TTL_MS = 30 * 24 * 60 * 60 * 1000;
const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"] as const;
/** Колонки в базе — только эти две (решение владельца). */
export const UTM_COLUMNS = ["utm_source", "utm_campaign"] as const;

/** Значение utm для базы: печатные символы без управляющих, до 100 знаков, иначе null. */
export function normalizeUtm(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  // eslint-disable-next-line no-control-regex
  const v = raw.replace(/[\u0000-\u001f\u007f<>"'`]/g, "").trim().slice(0, 100);
  return v ? v : null;
}

/** Поля для вставки: только непустые, чтобы без utm запрос был как раньше. */
export function utmColumns(d: { utm_source?: unknown; utm_campaign?: unknown }): Partial<Record<(typeof UTM_COLUMNS)[number], string>> {
  const out: Partial<Record<(typeof UTM_COLUMNS)[number], string>> = {};
  const s = normalizeUtm(d.utm_source);
  const c = normalizeUtm(d.utm_campaign);
  if (s) out.utm_source = s;
  if (c) out.utm_campaign = c;
  return out;
}

/** Адрес с utm_* — запомнить (новый рекламный заход перебивает старый). Никогда не бросает. */
export function captureUtm(search: string, nowMs: number = Date.now()): void {
  try {
    if (typeof window === "undefined") return;
    const q = new URLSearchParams(search);
    const got: Record<string, string> = {};
    for (const p of PARAMS) {
      const v = normalizeUtm(q.get(p));
      if (v) got[p] = v;
    }
    if (!Object.keys(got).length) return;
    window.localStorage.setItem(UTM_KEY, JSON.stringify({ ...got, at: nowMs }));
  } catch {
    /* аналитика не роняет страницу */
  }
}

/** utm_source / utm_campaign для анкеты: только свежие (30 дней). Никогда не бросает. */
export function readUtm(nowMs: number = Date.now()): { utm_source?: string; utm_campaign?: string } {
  try {
    if (typeof window === "undefined") return {};
    const raw = window.localStorage.getItem(UTM_KEY);
    if (!raw) return {};
    const v = JSON.parse(raw) as Record<string, unknown>;
    if (typeof v.at !== "number" || nowMs - v.at > UTM_TTL_MS) return {};
    const s = normalizeUtm(v.utm_source);
    const c = normalizeUtm(v.utm_campaign);
    return { ...(s ? { utm_source: s } : {}), ...(c ? { utm_campaign: c } : {}) };
  } catch {
    return {};
  }
}
